import { Box, CircularProgress } from "@mui/material";
import { useContext, useEffect } from "react";
import AuthContext from "./authContext";
import PageNotFound from "../pages/notFound";
import { Link, useLocation, useNavigate } from "react-router-dom";

const PrivateRoute = ({ children, access }) => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.url.includes("logout")) {
      window.location.href = "/web/logout";
    }

    if (auth.url.includes("login")) {
      navigate(auth.url);
      navigate(0);
    }

    if (
      auth.url.includes("changepass") &&
      location.pathname !== "/newweb/changepass"
    ) {
      navigate("/newweb/changepass");
      navigate(0);
    }
  }, [location.pathname, auth.url, navigate]);

  if (access < 1) {
    return <PageNotFound />;
  }

  if (auth.status === "") {
    return (
      <Box
        height={"80%"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (location.pathname === "/newweb/changepass") {
    return children;
  }

  return auth.status === "OK" && children;
};

export default PrivateRoute;
